import _ from 'lodash';
type WidgetQuery = {
  widget_id?: string | number;
  chart_type?: string;
  width?: number | null;
  height?: number | null;
  x_axis_position?: number | null;
  y_axis_position?: number | null;
  index?: string | number;
  widget_template?: { widget_display_type?: string[] };
};
type LayoutItem = {
  widget_id?: string | number;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  i?: string;
  static?: boolean;
  minW?: number;
  minH?: number;
  maxW?: number;
  maxH?: number;
  isResizable?: boolean;
};
type GenerateLayoutParams = {
  widgetQuery: WidgetQuery[];
  layout?: LayoutItem[];
  action?: string;
  type?: string;
};

const getWidgetConfig = (item: WidgetQuery) => {
  const chartType = item?.chart_type;
  const isGauge = chartType === 'gauge';
  const isTabular = chartType === 'tabular-report';
  const isPie = chartType === 'pie-chart';
  const isTable = chartType === 'table-report';
  const isCard = chartType === 'card';
  const isProgressBar = chartType === 'progress-bar';
  const isExternalButton =
    item?.widget_template?.widget_display_type?.[0] === 'external-link-button';
  const width =
    item?.width ||
    (isExternalButton || isTabular ? 1 : isGauge ? 2.2 : isTable ? 10 : 2.2);
  const height =
    item?.height ||
    (isExternalButton || isTabular || isCard
      ? 1
      : isGauge || isPie
        ? 6
        : isTable
          ? 15
          : isProgressBar
            ? 5
            : 6);
  const minW = isGauge
    ? 2.2
    : isTable
      ? 10
      : isCard || isExternalButton
        ? 1
        : 2;
  const minH =
    isGauge || isPie
      ? 6
      : isTable
        ? 15
        : isCard || isExternalButton
          ? 1
          : isProgressBar
            ? 5
            : 6;
  return {
    width,
    height,
    minW,
    minH,
    maxH: isExternalButton ? 2 : Infinity,
    isResizable: !isTabular,
  };
};

export const generateWidgetLayout = ({
  widgetQuery,
  layout = [],
  action,
  type,
}: GenerateLayoutParams): LayoutItem[] => {
  if (!widgetQuery?.length) {
    return [];
  }
  const maxY = layout.length
    ? Math.max(...layout.map(item => (item?.y ?? 0) + (item?.h ?? 0)))
    : Math.max(
        ...widgetQuery.map(
          item => (item?.y_axis_position ?? 0) + (item?.height ?? 0)
        )
      );
  const maxX = layout.length
    ? Math.max(...layout.map(item => (item?.x ?? 0) + (item?.w ?? 0)))
    : Math.max(
        ...widgetQuery.map(
          item => (item?.x_axis_position ?? 0) + (item?.width ?? 0)
        )
      );
  return _.map(widgetQuery, (item, index) => {
    const config = getWidgetConfig(item);
    const x =
      item?.x_axis_position != null
        ? item.x_axis_position
        : (layout[index]?.x ?? (maxX || (index * 4) % 6));
    const y =
      item?.y_axis_position != null
        ? item.y_axis_position
        : (layout[index]?.y ?? (maxY || Math.floor((index * 2) / 6) * 2));
    const isStatic = action === 'view' || type === 'home';
    return {
      widget_id: item?.widget_id,
      x,
      y,
      w: config.width,
      h: config.height,
      i: item?.index?.toString(),
      static: isStatic,
      minW: config.minW,
      minH: config.minH,
      maxW: Infinity,
      maxH: config.maxH,
      isResizable: isStatic ? false : config.isResizable,
    };
  });
};
